import React from 'react'
import { Link } from 'react-router-dom';

function SideBarItem({Item,isActive,onClick}) {
  
  const{id,displayText,navigate,rel,target,icon}=Item
  const styling=isActive?"active-tab":""
  const onStatusChange=()=>{
    onClick(id)
  }

  return (
    <li className={`sidebar-item ${styling}`} onClick={onStatusChange}>
    <Link
      className="sidebar-link "
      to={navigate}
      aria-expanded="false"
      target={target}
      rel={rel}
    >
      <span>
        <i className={`${icon} text-white`} style={{backgroundColor:"transparent"}} />
      </span>
      <span className="hide-menu fs-4 text-white">{displayText}</span>
    </Link>
  </li>

  )
}

export default SideBarItem